export default __webpack_public_path__ + "static/media/tatters.d5b121ec.jpg";